import gql from 'graphql-tag'

export const subscriptionRenew = gql`
  mutation SubscriptionRenew(
    $paymentData: PaymentDataInput!
    $deviceId: ID!
    $publicAccess: Boolean
  ) {
    initTransaction(paymentData: $paymentData, deviceId: $deviceId, publicAccess: $publicAccess) {
      code
      message
      transId
      redirect
    }
  }
`
